export default {
    install: (app) => {
        app.config.globalProperties.$getCustomColorClass = (storeName) => {
            if (!storeName) return '';
            if (storeName.includes("comda")) return 'comdaColor';
            if (storeName.includes("mlp")) return 'mlpColor';
            return '';
        };

        app.config.globalProperties.$getTranslatedColorWord = (str) => {
            if(window.Shopify.country && str == 'color') {
                return (window.Shopify.country == 'US') ? 'color' : 'colour';
            }
            return '';
        };

        app.config.globalProperties.$getCustomColorBeforeClass = (storeName) => {
            if (!storeName) return '';
            if (storeName.includes("comda")) return 'comdaColorBefore';
            if (storeName.includes("mlp")) return 'mlpColorBefore';
            return '';
        };

        app.config.globalProperties.$getCustomColorAfterClass = (storeName) => {
            if (!storeName) return '';
            if (storeName.includes("comda")) return 'comdaColorAfter';
            if (storeName.includes("mlp")) return 'mlpColorAfter';
            return '';
        };

        app.config.globalProperties.$getCustomBackgroundColorClass = (storeName) => {
            if (!storeName) return '';
            if (storeName.includes("comda")) return 'comdaBackgroundColor';
            if (storeName.includes("mlp")) return 'mlpBackgroundColor';
            return '';
        };

        app.config.globalProperties.$getCustomBackgroundColorHoverClass = (storeName) => {
            if (!storeName) return '';
            if (storeName.includes("comda")) return 'comdaBackgroundColorHover';
            if (storeName.includes("mlp")) return 'mlpBackgroundColorHover';
            return '';
        };

        app.config.globalProperties.$getCustomFontClass = (storeName) => {
            if (!storeName) return '';
            if (storeName.includes("comda")) return 'comdaFont';
            if (storeName.includes("mlp")) return 'mlpFont';
            return '';
        };
    }
};
